import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  emailAddressValidator,
  newPhoneNumbervalidator,
  phoneNumbervalidatorWithPrefix
} from "../../shared/validators/input-validators";
import {ForgetPassswordService} from "../../services/forget-passsword.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrl: './forget-password.component.scss'
})
export class ForgetPasswordComponent implements OnInit{

  viewType: string = 'phoneNumber';
  form: FormGroup

  constructor(
    private fb: FormBuilder,
    private forgotPasswordService: ForgetPassswordService,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.changeView('phoneNumber')
  }

  onSubmit(): void {
    if (this.form.valid) {
      // Form value is correct
      if (this.viewType === 'phoneNumber') {
        const phoneNumber = `255${this.form.value.phoneNumber}`;
        const type = 'phone'
        this.forgotPasswordService.citizenVerifyOtpNumber(phoneNumber).subscribe({
          next: () => {
            this.router.navigate([`/verify-otp/setPass/${type}/${phoneNumber}`]);
          },
          error: (err) => {
            console.log('Error during verification:', err);
          }
        });
      } else if(this.viewType === 'emailAddress'){
        let email = this.form.value.emailAddress
        const type = 'email';
        this.forgotPasswordService.citizenVerifyEmail(email).subscribe({
          next : () => {
            this.router.navigate([`/verify-otp/setPass/${type}/${email}`]);
          },
          error: (err) => {
            console.log('Error during verification:', err);
          }
        })
      }
    } else {
      console.log('Form is invalid');
    }
  }


  changeView(viewType: string): void {
    this.viewType = viewType;
    if (this.viewType === 'phoneNumber') {
      this.form = this.fb.group({
        phoneNumber: [null, [Validators.required, Validators.pattern(newPhoneNumbervalidator)]],
      })
    } else if(this.viewType === 'emailAddress') {
      this.form = this.fb.group({
        emailAddress: [null, [Validators.required, Validators.pattern(emailAddressValidator)]],
      })
    }
  }

  get phoneNumber() {
    return this.form.get('phoneNumber');
  }

  get emailAddress() {
    return this.form.get('emailAddress');
  }

}
